/*****************************************************************************************************
 * Load Libraries
 */
/** Collapsible Button */
import CollapsibleButton from '@RESOURCES/js/services/collapsible/CollapsibleButton';
import Collapsible from '@RESOURCES/js/services/collapsible/Collapsible';

global.CollapsibleButton = CollapsibleButton;

global.Collapsible = Collapsible;

/*****************************************************************************************************
 * Load All Internal Components
 */
Vue.component('subscription-form', require('@RESOURCES/js/components/subscription/SubscriptionForm').default);
Vue.component('fake-checkbox', require('@RESOURCES/js/components/FakeCheckboxComponent.vue').default);
Vue.component('signup-form', require('@RESOURCES/js/components/signupForm/SignUpForm.vue').default);
Vue.component('show-more-show-less-button', require('@RESOURCES/js/components/operator_list/ShowMoreShowLessButton.vue').default);